import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'gl',
  Pagination: {
    items_per_page: '/ páxina',
    jump_to: 'Ir a',
    jump_to_confirm: 'confirmar',
    page: '',
    prev_page: 'Páxina anterior',
    next_page: 'Páxina seguinte',
    prev_5: '5 páxinas previas',
    next_5: '5 páxinas seguintes',
    prev_3: '3 páxinas previas',
    next_3: '3 páxinas seguintes',
  },
  DatePicker: {
    lang: {
      placeholder: 'Escolla data',
      rangePlaceholder: [
        'Data inicial',
        'Data final',
      ],
      locale: 'gl_ES',
      today: 'Hoxe',
      now: 'Agora',
      backToToday: 'Voltar a hoxe',
      ok: 'Aceptar',
      clear: 'Limpar',
      month: 'Mes',
      year: 'Ano',
      timeSelect: 'Seleccionar hora',
      dateSelect: 'Seleccionar data',
      monthSelect: 'Elexir un mes',
      yearSelect: 'Elexir un año',
      decadeSelect: 'Elexir unha década',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mes anterior (PageUp)',
      nextMonth: 'Mes seguinte (PageDown)',
      previousYear: 'Ano anterior (Control + left)',
      nextYear: 'Ano seguinte (Control + right)',
      previousDecade: 'Década anterior',
      nextDecade: 'Década seguinte',
      previousCentury: 'Século anterior',
      nextCentury: 'Século seguinte',
    },
    timePickerLocale: {
      placeholder: 'Escolla hora',
    },
  },
  TimePicker: {
    placeholder: 'Escolla hora',
  },
  Calendar: {
    lang: {
      placeholder: 'Escolla data',
      rangePlaceholder: [
        'Data inicial',
        'Data final',
      ],
      locale: 'gl_ES',
      today: 'Hoxe',
      now: 'Agora',
      backToToday: 'Voltar a hoxe',
      ok: 'Aceptar',
      clear: 'Limpar',
      month: 'Mes',
      year: 'Ano',
      timeSelect: 'Seleccionar hora',
      dateSelect: 'Seleccionar data',
      monthSelect: 'Elexir un mes',
      yearSelect: 'Elexir un año',
      decadeSelect: 'Elexir unha década',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mes anterior (PageUp)',
      nextMonth: 'Mes seguinte (PageDown)',
      previousYear: 'Ano anterior (Control + left)',
      nextYear: 'Ano seguinte (Control + right)',
      previousDecade: 'Década anterior',
      nextDecade: 'Década seguinte',
      previousCentury: 'Século anterior',
      nextCentury: 'Século seguinte',
    },
    timePickerLocale: {
      placeholder: 'Escolla hora',
    },
  },
  global: {
    placeholder: 'Escolla',
  },
  Table: {
    filterTitle: 'Filtrar menú',
    filterConfirm: 'Aceptar',
    filterReset: 'Reiniciar',
    selectAll: 'Seleccionar todo',
    selectInvert: 'Invertir selección',
    sortTitle: 'Ordenar',
  },
  Modal: {
    okText: 'Aceptar',
    cancelText: 'Cancelar',
    justOkText: 'Aceptar',
  },
  Popconfirm: {
    okText: 'Aceptar',
    cancelText: 'Cancelar',
  },
  Transfer: {
    searchPlaceholder: 'Buscar aquí',
    itemUnit: 'elemento',
    itemsUnit: 'elementos',
  },
  Upload: {
    uploading: 'Subindo...',
    removeFile: 'Eliminar arquivo',
    uploadError: 'Error ao subir o arquivo',
    previewFile: 'Vista previa',
    downloadFile: 'Descargar arquivo',
  },
  Empty: {
    description: 'Non hai datos',
  },
  Icon: {
    icon: 'icona',
  },
  Text: {
    edit: 'editar',
    copy: 'copiar',
    copied: 'copiado',
    expand: 'expandir',
  },
  PageHeader: {
    back: 'voltar',
  },
  Form: {
    defaultValidateMessages: {
      default: 'Error de validación do campo ${label}',
      required: 'Por favor complete ${label}',
      enum: '${label} ten que ser un de [${enum}]',
      whitespace: '${label} non pode ter ningún caracter en branco',
      date: {
        format: 'O formato de data ${label} non é válido',
        parse: '${label} non se pode convertir a unha data',
        invalid: '${label} é unha data inválida',
      },
      types: {
        string: '${label} non é un ${type} válido',
        method: '${label} non é un ${type} válido',
        array: '${label} non é un ${type} válido',
        object: '${label} non é un ${type} válido',
        number: '${label} non é un ${type} válido',
        date: '${label} non é un ${type} válido',
        boolean: '${label} non é un ${type} válido',
        integer: '${label} non é un ${type} válido',
        float: '${label} non é un ${type} válido',
        regexp: '${label} non é un ${type} válido',
        email: '${label} non é un ${type} válido',
        url: '${label} non é un ${type} válido',
        hex: '${label} non é un ${type} válido',
      },
      string: {
        len: '${label} debe ter ${len} caracteres',
        min: '${label} debe ter como mínimo ${min} caracteres',
        max: '${label} debe ter ata ${max} caracteres',
        range: '${label} debe ter entre ${min}-${max} caracteres',
      },
      number: {
        len: '${label} debe ser igual a ${len}',
        min: '${label} valor mínimo é ${min}',
        max: '${label} valor máximo é ${max}',
        range: '${label} debe estar entre ${min}-${max}',
      },
      array: {
        len: 'Debe ser ${len} ${label}',
        min: 'Como mínimo ${min} ${label}',
        max: 'Como máximo ${max} ${label}',
        range: 'O valor de ${label} debe estar entre ${min}-${max}',
      },
      pattern: {
        mismatch: '${label} non coincide co patrón ${pattern}',
      },
    },
  },
};

export default localeValues;
